import { CustomerLogo } from 'components/_common/Icons';
import LeftChevronSvg from 'components/_common/Icons/SVGIcons/LeftChevronSvg';
import { useState } from 'react';
import { Link, Outlet } from 'react-router-dom';
import { loginRoutes } from 'routes/admin/AdminRoutes';
import { getCustomerContentPageRoute } from 'routes/customer/CustomerRoutes';
import PublicRoute from 'routes/PublicRoute';

// import 'LoginLeft' from from 'assets/images/profile.svg';
export default function ForgotPaswordLayout() {
  const [showBackButton, setShowBackButton] = useState(true);
  return (
    <PublicRoute>
      <div className="container-fluid login-layout-wrapper">
        <div className="row justify-content-center">
          <div className="col-12 col-sm-6 col-md-4 login-main-screen p-0 forgot-password">
            <div>
              {/* back icon */}
              {showBackButton && (
                <div className="row mb-3">
                  <div className="col-auto">
                    <Link
                      to={loginRoutes.login.path}
                      className="icon-circle-back d-flex align-items-center justify-content-center float-start"
                    >
                      <LeftChevronSvg />
                    </Link>
                  </div>
                </div>
              )}
              {/* back icon */}
              <div className="login-main-right ">
                <Outlet context={{ setShowBackButton }} />
              </div>
            </div>
          </div>
          <div className="footer d-flex flex-column flex-md-row justify-content-between align-items-center py-3 py-md-0 gap-3 gap-md-0 w-100">
            <a href="#" className="d-flex align-items-center gap-2">
              <span>© {new Date().getFullYear()} My Local Gun Shop</span>{' '}
              <img
                src={CustomerLogo}
                alt="Logo"
                style={{ height: '1.2em', width: 'auto', verticalAlign: 'middle' }}
              />
            </a>
            <div className="footer-links d-flex flex-column flex-md-row justify-content-between align-items-center gap-3 gap-md-4">
              <a
                href={getCustomerContentPageRoute('terms_and_conditions')}
                className="link-underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms and Conditions
              </a>
              <a
                href={getCustomerContentPageRoute('privacy_policy')}
                className="link-underline"
                target="_blank" // optional: opens in a new tab
                rel="noopener noreferrer" // recommended for security when using target="_blank"
              >
                Privacy Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </PublicRoute>
  );
}
